import { Component, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  DwCardBaseComponent,
  DwComponent,
  DwComponentType,
  DwDataFormatService,
  DwFormatTypes,
  DwMetaDataListCardConfigData,
  DwQueryMetaData,
  DwRoutingService
} from '@devwareapps/devware-cap';
import {
  AppMetaDataItemNames,
  AssignmentByStudentQueryEntity,
  AssignmentLessonWithProgressForStudentQueryEntity,
  LessonTypeAllItems,
  RoAssignmentStudentCourseLessonProgressEntity
} from '../../../../../meta-data/app-meta-data.service';
import { CourseNavigationService } from '../../../../courses/services/course-navigation.service';
import { DateTimeUtilService } from '../../../../shared/util/date-time-util.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Assignment Card - My Assignments Redesign (Data Card)',
  key: 'assignmentCardMyAssignmentsRedesign',
  componentType: DwComponentType.card,
  isGlobal: true,
  parentItemName: AppMetaDataItemNames.AssignmentCourseLesson,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-assignment-card-my-assignments-redesign',
  templateUrl: './assignment-card-my-assignments-redesign.component.html',
  styleUrls: ['./assignment-card-my-assignments-redesign.component.scss']
})
export class AssignmentCardMyAssignmentsRedesignComponent
implements DwCardBaseComponent<any, AssignmentLessonWithProgressForStudentQueryEntity>, OnChanges {
  cardConfig?: any;
  @Input() data?: AssignmentByStudentQueryEntity;
  resolvedContext?: any;
  cardClick: EventEmitter<any> = new EventEmitter<any>();
  dueDateTime: string;
  percentCompleteText: string;
  lessonCount: number;
  dueClass: string;
  dueInMinutes: number;
  currentDate: string;
  currentDateFormatted: string;
  lessonProgress: RoAssignmentStudentCourseLessonProgressEntity[] = [];
  preventClick = false;
  dueClass2: string;
  isOverdue = false;
  isDueSoon = false;

  queryMetaData?: DwQueryMetaData;
  maxLessonsToShow = 3;
  quizLessonTypeId = LessonTypeAllItems.Quiz;
  readonly skeletonRows = [1, 2, 3];
  isLoading = true;

  constructor(
    private dwDataFormatService: DwDataFormatService,
    private dwRoutingService: DwRoutingService,
    private courseNavigationService: CourseNavigationService,
    private dateTimeUtilService: DateTimeUtilService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.isLoading = !this.hasCardData();

      if (this.hasCardData()) {
        this.setupCard();
      }
    }
  }

  setupCard() {
    if (!this.hasCardData()) {
      this.isLoading = true;
      return;
    }

    this.isLoading = false;
    this.preventClick = false;
    this.dueClass = '';
    this.dueClass2 = '';
    const dueDate = new Date(this.data?.DueDateTime);
    this.dueDateTime = dueDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

    this.lessonCount = this.data?.AssignmentIdRoAssignmentStudentCourseLessonProgress?.length || 1;

    const currentDate = this.dateTimeUtilService.getCurrentDateTime();
    this.currentDateFormatted = this.dwDataFormatService.formatValue(currentDate, {
      formatType: DwFormatTypes.datetime,
      useGmtDateTime: true
    });

    this.dueInMinutes = this.dateTimeUtilService.calcDurationMinutes(
      currentDate,
      this.data?.DueDateTime,
      null,
      null,
      null,
      true
    );

    if (this.dueInMinutes < 0 && !this.data?.CompletedDateTime) {
      this.dueClass = 'dw-red';
      this.dueClass2 = 'assignment-past-due';
    }

    if (this.dueInMinutes >= 0 && this.dueInMinutes < 60 * 24) {
      this.dueClass = 'dw-orange';
      this.dueClass2 = 'assignment-due-soon';
    }

    // Progress color state
    this.isOverdue = this.dueInMinutes < 0 && !this.data?.CompletedDateTime;
    this.isDueSoon = !this.isOverdue && this.dueInMinutes >= 0 && this.dueInMinutes < 60 * 24;

    this.lessonProgress = [];

    for (const progress of this.data?.AssignmentIdRoAssignmentStudentCourseLessonProgress || []) {
      if (!progress?.LessonComplete || this.data?.AssignmentStudentPercentComplete === 100) {
        this.lessonProgress.push(progress);
      }

      if (this.lessonProgress.length >= this.maxLessonsToShow) {
        break;
      }
    }
  }

  click() {
    if (this.preventClick) {
      return;
    }

    const url = `/my-assignments/view/${this.data?.AssignmentStudentAssignmentStudentId}`;
    this.dwRoutingService.navigateToUrl(url, null);
  }

  clickProgress(lesson: RoAssignmentStudentCourseLessonProgressEntity) {
    this.courseNavigationService.navigateToLesson({
      courseId: lesson.CourseId,
      moduleId: lesson.CourseModuleId,
      lessonId: lesson.CourseLessonId
    });

    this.preventClick = true;
  }

  private hasCardData(): boolean {
    return !!this.data?.AssignmentStudentAssignmentStudentId;
  }
}
